import $ from 'jquery';
import {sendSms, addCard, rebuildCard, getCardBalance} from '../api/api';
import isViewport from '../../scripts/util/window/isViewport';
import heightAnimate from '../../scripts/util/animate/heightAnimate';
import {sm, lg} from '../../scripts/util/window/isViewport';
import _ from 'underscore';
import format from 'number-format.js';

export default class MyLoyalty {
	constructor(options) {
		const defaults = {
			el: '.js-my-loyalty',

			dom: {
				card: '.js-loyalty-card',
				cardTmpl: '.js-loyalty-tmpl',
				info: '.js-loyalty-info',
				toggleHistory: '.js-toggle-history',
				transactions: '.js-loyalty-transactions',
				transaction: '.js-transaction',
				showTransactions: '.js-show-transactions',
				restore: '.js-loyalty-restore',
				sms: '.js-loyalty-sms',
				close: '.js-loyalty-close',
				form: '.js-loyalty-form',
				formValidation: '.js-card-order-validation',
				formStatus: '.js-card-order-status',
				formStatusText: '.my-loyalty__status-text',
				smsForm: '.js-loyalty-sms-form',
				cardOrder: '.js-sms-card-order',
				statusSuccess: '.js-sms-status-success',
				bindStatus: '.js-card-bind-status',
				mobileStatusSuccess: '.js-mobile-sms-status-success',
				smsSend: '.js-sms-send',
				smsText: '.js-sms-text',
				smsPassword: '.js-sms-password',
				smsInput: '.js-sms-input',
				phone: '.js-contacts-input',
				addCard: '.js-loyalty.add-card',
				cardFiel: '.js-field-card',
				cardContainer: '.js-loyalty-card-container',
				cardTable: '.js-loyalty-card-table',
				smsValidation: '.js-sms-validation',
				selectInput: '.js-select-input',
				price: '.js-price'
			},

			classes: {
				el: {
					state: {
						initial: 'my-loyalty_state_initial',
						list: 'my-loyalty_state_list'
					}
				},
				status: {
					state: {
						hidden: 'my-loyalty__status-text_state_hidden',
						visible: 'my-loyalty__status-text_state_visible',
						error: 'my-loyalty__status-text_error'
					}
				},
				mobileStatus: {
					state: {
						hidden: 'my-loyalty__message_state_hidden',
						visible: 'my-loyalty__message_state_visible'
					}
				},
				cardOrder: {
					state: {
						hidden: 'my-loyalty__linking_state_hidden'
					}
				},
				smsPassword: {
					state: {
						hidden: 'my-loyalty__fields_state_hidden'
					}
				},
				table: {
					state: {
						hidden: 'my-loyalty__table_hidden'
					}
				},
				card: {
					state: {
						opened: 'loyalty-card_state_opened'
					},
					tmpl: 'js-loyalty-tmpl'
				},
				close: {
					state: {
						visible: 'my-loyalty__close_state_visible'
					}
				},
				form: {
					state: {
						opened: 'my-loyalty__form_state_opened'
					}
				},
				formStatus: {
					state: {
						visible: 'my-loyalty__success_state_visible',
						error: 'my-loyalty__success_state_error'
					}
				},
				transaction: {
					state: {
						hidden: 'loyalty-card__row_state_hidden'
					}
				},
				notification: {
					state: {
						visible: 'my-loyalty__notification_visible'
					}
				}
			}
		};

		this.cardData = {
			data: {
				level: 'Black',
				score: 10,
				date: '48 февраля 2458',
				number: 1001,
				cardNeedPay: 10000,
				cardNextNeedPay: 23900,
				transactions: [{
					date: '12 октября 2016',
					time: '12:00',
					score: '+2 340'
				}]
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$card = this.$el.find(this.options.dom.card);
		this.$info = this.$el.find(this.options.dom.info);
		this.$toggleHistory = this.$el.find(this.options.dom.toggleHistory);
		this.$transactions = this.$el.find(this.options.dom.transactions);
		this.$transaction = this.$el.find(this.options.dom.transaction);
		this.$showTransactions = this.$el.find(this.options.dom.showTransactions);
		this.$restore = this.$el.find(this.options.dom.restore);
		this.$sms = this.$el.find(this.options.dom.sms);
		this.$close = this.$el.find(this.options.dom.close);
		this.$form = this.$el.find(this.options.dom.form);
		this.$formValidation = this.$el.find(this.options.dom.formValidation);
		this.$formStatus = this.$el.find(this.options.dom.formStatus);
		this.$smsForm = this.$el.find(this.options.dom.smsForm);
		this.$cardOrder = this.$el.find(this.options.dom.cardOrder);
		this.$statusSuccess = this.$el.find(this.options.dom.statusSuccess);
		this.$mobileStatusSuccess = this.$el.find(this.options.dom.mobileStatusSuccess);
		this.$smsSend = this.$el.find(this.options.dom.smsSend);
		this.$smsText = this.$el.find(this.options.dom.smsText);
		this.$phone = this.$el.find(this.options.dom.phone);
		this.$cardFiel = this.$el.find(this.options.dom.cardFiel);
		this.$smsPassword = this.$el.find(this.options.dom.smsPassword);
		this.$smsInput = this.$el.find(this.options.dom.smsInput);
		this.$addCard = this.$el.find(this.options.dom.addCard);
		this.$cardContainer = this.$el.find(this.options.dom.cardContainer);
		this.$cardTable = this.$el.find(this.options.dom.cardTable);
		this.$smsValidation = this.$el.find(this.options.dom.smsValidation);
		this.$selectInput = this.$el.find(this.options.dom.selectInput);
		this.$bindStatus = this.$el.find(this.options.dom.bindStatus);



		const mustacheStyleSyntax = {
			evaluate: /\{\{(.+?)\}\}/g,
			interpolate: /\{\{=(.+?)\}\}/g,
			escape: /\{\{-(.+?)\}\}/g
		};

		const tmpl = $('#loyaltyCardTmpl');

		if (tmpl.length) {
			this.$cardTmp = _.template(_.unescape($('#loyaltyCardTmpl').html().trim()), mustacheStyleSyntax);
		}

		return this;
	}

	onClick(e) {
		const $target = $(e.target);
		const $card = $target.closest(this.$card);
		const $openCard = this.$cardContainer.find(`.${this.options.classes.card.state.opened}`);
		const $cards = $card.siblings();
		const $toggleHistory = $card.find(this.options.dom.toggleHistory);
		const $transactions = $card.find(this.options.dom.transactions);
		const delay = $openCard.length ? 0.4 : 0;

		if ((isViewport(sm) && !$target.hasClass('link')) || (!isViewport(sm) && $target.hasClass('js-toggle-history'))) {
			$cards.each(item => {
				const $el = $cards.eq(item);
				const $transact = $el.find(this.options.dom.transactions);

				if ($el.hasClass(this.options.classes.card.state.opened) && $transactions.length) {
					$el.removeClass(this.options.classes.card.state.opened);
					$el.find(this.options.dom.toggleHistory).text('Показать историю транзакций');
					heightAnimate($transact, 0.4, 'close');
				}
			});

			if ($transactions.length) {
				if (!$card.hasClass(this.options.classes.card.state.opened)) {
					$toggleHistory.text('Скрыть историю транзакций');
					heightAnimate($transactions, 0.4, 'open', delay);
					setTimeout(() => {
						$card.toggleClass(this.options.classes.card.state.opened);
					}, delay * 1000);
				} else {
					$toggleHistory.text('Показать историю транзакций');
					heightAnimate($transactions, 0.4, 'close');
					$card.toggleClass(this.options.classes.card.state.opened);
				}
			}
		}
	}

	setInitState = e => {
		const dom = this.options.dom;
		const options = this.options.classes;
		const $target = $(e.target);
		const $el = $target.closest(this.options.el);
		const $table = $el.find(dom.cardTable);
		const $cards = $target.find(dom.card).not(dom.cardTmpl);

		if ($cards.length === 0) {
			$el.removeClass(options.el.state.list);
			$el.addClass(options.el.state.initial);
			$table.addClass(options.table.state.hidden);
			heightAnimate(this.$smsForm, 0);
			heightAnimate(this.$form, 0);
			this.$cardOrder.removeClass(options.cardOrder.state.hidden);
		}
	};

	setTransactionDisplaying() {
		this.$card.each((i, card) => {
			const $card = $(card);
			const $transactions = $card.find(this.options.dom.transaction);
			if ($transactions.length) {
				$transactions.each((j, transaction) => {
					const $transaction = $(transaction);
					if (j > 4) {
						$transaction.addClass(this.options.classes.transaction.state.hidden);
					}
				});
			}

		});
	}

	showMoreTransaction(e) {
		const $target = $(e.currentTarget);
		const $card = $target.closest(this.options.dom.card);
		const $transactions = $card.find(this.options.dom.transaction);
		const $hiddenTransactions = $transactions.filter('.' + this.options.classes.transaction.state.hidden);
		if ($hiddenTransactions.length) {
			$hiddenTransactions.each((i, transaction) => {
				const $transaction = $(transaction);
				if (i < 3) {
					$transaction.removeClass(this.options.classes.transaction.state.hidden);
				}
			});
		}
		if ($hiddenTransactions.length <= 3) {
			$target.addClass('hidden');
		}
	}

	showForm() {
		this.$close.addClass(this.options.classes.close.state.visible);
		if (!this.$form.hasClass(this.options.classes.form.state.opened)) {
			heightAnimate(this.$form, 0.4);
		}
		this.$form.addClass(this.options.classes.form.state.opened);
	}

	showSmsForm() {
		if (!this.$smsForm.hasClass(this.options.classes.form.state.opened)) {
			heightAnimate(this.$smsForm, 0.4);
		}
		this.$smsForm.addClass(this.options.classes.form.state.opened);
	}

	closeForm() {
		this.$close.removeClass(this.options.classes.close.state.visible);
		if (this.$form.hasClass(this.options.classes.form.state.opened)) {
			heightAnimate(this.$form, 0.4, 'close');
		}
		this.$form.removeClass(this.options.classes.form.state.opened);
		setTimeout(() => {
			this.$form[0].reset();
		}, 400);
	}

	setSmsState(message = 'Ошибка', fail = false) {

		this.$smsSend.removeClass(this.options.classes.status.state.visible);
		this.$smsSend.addClass(this.options.classes.status.state.hidden);

		if (!isViewport(lg)) {
			this.$statusSuccess.removeClass(this.options.classes.status.state.hidden);
			this.$smsText.text('Выслать SMS повторно');
			this.$statusSuccess.find('span').html(message);
			if (fail) {
				this.$statusSuccess.addClass(this.options.classes.status.state.error);
			} else {
				this.$statusSuccess.removeClass(this.options.classes.status.state.error);
			}
			this.$statusSuccess.addClass(this.options.classes.status.state.visible);
		} else {
			this.$mobileStatusSuccess.removeClass(this.options.classes.mobileStatus.state.hidden);
			this.$mobileStatusSuccess.html(message);
			this.$mobileStatusSuccess.fadeTo(300, 1, () => {
				this.$smsText.text('Выслать SMS повторно');
				this.$mobileStatusSuccess.addClass(this.options.classes.mobileStatus.state.visible);
			});
		}

		if (!fail) {
			this.$smsPassword.removeClass(this.options.classes.smsPassword.state.hidden);
			this.$cardOrder.addClass(this.options.classes.cardOrder.state.hidden);
		}

		setTimeout(() => {
			if (!isViewport(lg)) {
				this.$statusSuccess.removeClass(this.options.classes.status.state.visible);
				this.$statusSuccess.addClass(this.options.classes.status.state.hidden);
				this.$smsSend.removeClass(this.options.classes.status.state.hidden);

				this.$smsSend.addClass(this.options.classes.status.state.visible);
			} else {
				this.$mobileStatusSuccess.fadeTo(300, 0, () => {
					this.$mobileStatusSuccess.removeClass(this.options.classes.mobileStatus.state.visible);
					this.$mobileStatusSuccess.addClass(this.options.classes.mobileStatus.state.hidden);
					this.$smsSend.removeClass(this.options.classes.status.state.hidden);

					this.$smsSend.addClass(this.options.classes.status.state.visible);

				});
			}
		}, 3000);
	}

	setBindState(message = 'Ошибка') {
		this.$smsSend.removeClass(this.options.classes.status.state.visible);
		this.$smsSend.addClass(this.options.classes.status.state.hidden);

		if (!isViewport(lg)) {
			this.$bindStatus.removeClass(this.options.classes.status.state.hidden);
			this.$bindStatus.find('span').html(message);
			this.$bindStatus.addClass(this.options.classes.status.state.visible);
		} else {
			this.$mobileStatusSuccess.removeClass(this.options.classes.mobileStatus.state.hidden);
			this.$mobileStatusSuccess.html(message);
			this.$mobileStatusSuccess.fadeTo(300, 1, () => {
				this.$mobileStatusSuccess.addClass(this.options.classes.mobileStatus.state.visible);
			});
		}

		setTimeout(() => {
			if (!isViewport(lg)) {
				this.$bindStatus.removeClass(this.options.classes.status.state.visible);
				this.$bindStatus.addClass(this.options.classes.status.state.hidden);
			} else {
				this.$mobileStatusSuccess.fadeTo(300, 0, () => {
					this.$mobileStatusSuccess.removeClass(this.options.classes.mobileStatus.state.visible);
					this.$mobileStatusSuccess.addClass(this.options.classes.mobileStatus.state.hidden);
				});
			}
		}, 3000);
	}

	sendSms() {
		const query = {
			a: 'sms',
			card: this.$cardFiel.val().replace(/\s/g, ''),
			phone: this.$phone.val()
		};

		sendSms(query).then(
			data => this.setSmsState(data.message),
			data => this.setSmsState(data.message, true)
		);
	}

	setStatusMsg = ($form, msg, error = false) => {
		const $status = $form.find(this.options.dom.formStatus);
		const errorClass = this.options.classes.formStatus.state.error;
		const $statusMsg = $status.find(this.options.dom.formStatusText);
		$status.addClass(this.options.classes.formStatus.state.visible);
		if (error) {
			$status.addClass(errorClass);
		} else {
			$status.removeClass(errorClass);
		}
		$statusMsg.text(msg);
	};

	sendForm(e) {
		const $target = $(e.currentTarget);
		const $form = $target.closest('form');
		const $data = $form.serialize();

		rebuildCard($data).then(
			data => {
				this.setStatusMsg($form, data.message);
				$target.addClass('hidden');
			},
			data => this.setStatusMsg($form, data.message, true)
		);
	}

	insertCard(data) {
		const newNode = $(this.$cardTmp(data));
		const $loyaltyCardClone = this.$card.eq(0).clone();
		$loyaltyCardClone.empty();
		$loyaltyCardClone.removeClass(this.options.classes.card.tmpl);
		this.$cardContainer.append($loyaltyCardClone.append(newNode));
		this.$cardTable.removeClass(this.options.classes.table.state.hidden);
		this.$card = this.$el.find(this.options.dom.card);
		this.$price = this.$el.find(this.options.dom.price);
		$loyaltyCardClone.find(this.options.dom.info).on('click', this.onClick.bind(this));
		$loyaltyCardClone.find('.js-scrollbar').mCustomScrollbar({
			theme: 'custom',
			scrollInertia: 0
		});
		this.setTransactionDisplaying();
		if (this.$el.hasClass(this.options.classes.el.state.initial)) {
			this.$el.removeClass(this.options.classes.el.state.initial);
			this.$el.addClass(this.options.classes.el.state.list);
			this.$selectInput.attr('required', true);
		}
		this.$smsPassword.addClass(this.options.classes.smsPassword.state.hidden);
		heightAnimate(this.$smsForm, 0, 'close');
		heightAnimate(this.$form, 0, 'close');
		this.$smsForm.removeClass(this.options.classes.form.state.opened);
		this.$smsText.text('Выслать SMS');
		this.$cardFiel.val('');
		this.$phone.val('');
		this.$smsInput.val('');
		this.getDom();
		this.$showTransactions.on('click', this.showMoreTransaction.bind(this));
		this.$price.each((i, elem) => {
			const $price = parseInt($(elem).text(), 10);
			if (!isNaN($price)) {
				$(elem).text(format('# ##0.## ₽', $price));
			}
		});
	}

	bindCard() {
		const query = {
			a: 'link',
			card: this.$cardFiel.val().replace(/\s/g, ''),
			phone: this.$phone.val(),
			code: this.$smsInput.val()
		};
		// TODO передавать реальные данные как будет готов бекенд
		this.cardData.data.number = query.card;
		getCardBalance({a: 'balance', card: query.card}).then(
			data => {
				this.cardData.data.score = data.balance;
				addCard(query).then(
					() => this.insertCard(this.cardData),
					res => this.setBindState(res.message)
				);
			},
			data => this.setBindState(data.message)
		);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.setTransactionDisplaying();
			this.$info.on('click', this.onClick.bind(this));
			this.$showTransactions.on('click', this.showMoreTransaction.bind(this));
			this.$restore.on('click', this.showForm.bind(this));
			this.$sms.on('click', e => this.showSmsForm(e));
			this.$close.on('click', this.closeForm.bind(this));
			this.$smsValidation.on('valid', e => this.sendSms(e));
			this.$smsForm.on('submit', e => this.bindCard(e));
			this.$cardContainer.on('unbindCard', this.setInitState);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/my-loyalty/my-loyalty.js
 **/